<mat-toolbar>
  <span translate>SYNC</span>
</mat-toolbar>

@if (isAdmin) {
  <div class="row mt-4">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">Axing20 --> MeasureServer sync (Admins only)</div>
        <div class="card-body">
          <p>Az alábbi sync gombra kattintva indítunk egy háttérfolyamatot, ami lekéri az axing20-tól:</p>
          <ul>
            <li>Cégek</li>
            <li>Telephelyek</li>
            <li>Felhasználók</li>
          </ul>
          <p>Ha az axingid nem szerepel még measure szerver db-ben, akkor létrehozzuk, egyébként update-eljük.</p>
          <button mat-raised-button (click)="syncAxing()" color="primary">Sync axing</button>
        </div>
      </div>
    </div>
  </div>
}
